import api from 'config/axios';
import AppService from 'common/app-service';

export interface FileAccessGrantCreateDto {
  personId: number;
  carrierBranchId: number;
}

export interface FileAccessCarrierDetails {
  id: number;
  documentNumber: string;
  tradeName: string;
  rootTradeName?: string;
  rootCompanyName?: string;
}

export interface FileAccessGrantViewDto {
  id: number;
  personId: number;
  carrierBranchId: number;
  carrierBranchDetails: FileAccessCarrierDetails;
}

export interface FileAccessGrantListFilters {
  personName?: string;
  personEmail?: string;
  carrierBranchTradeName?: string;
  carrierBranchDocumentNumber?: string;
}

export interface FileAccessGrantAdminViewDto {
  id: number;
  personDetails: {
    id: number;
    name: string;
    email: string;
  };
  carrierBranchDetails: {
    id: number;
    documentNumber: string;
    tradeName: string;
    companyName: string;
  };
}

export interface FileAccessGrantAdminListResponse {
  items: FileAccessGrantAdminViewDto[];
  page: number;
  limit: number;
  total: number;
}

export interface DistinctPersonDto {
  id: number;
  name: string;
  email: string;
}

export interface DistinctCarrierBranchDto {
  id: number;
  documentNumber: string;
  tradeName: string;
  companyName?: string;
  rootTradeName?: string;
  rootCompanyName?: string;
}

export interface DistinctEntitiesDto {
  carrierBranches: DistinctCarrierBranchDto[];
  persons: DistinctPersonDto[];
}

export default class FileAccessGrantService extends AppService {
  constructor() {
    super('file-access-grant', api);
  }

  async create(payload: FileAccessGrantCreateDto): Promise<FileAccessGrantViewDto> {
    const response = await this.api.post<FileAccessGrantViewDto>(this.root(''), payload);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await this.api.delete(this.root(`${id}`));
  }

  async list(personId: number): Promise<FileAccessGrantViewDto[]> {
    const response = await this.api.get<FileAccessGrantViewDto[]>(this.root(`person/${personId}`));
    return response.data;
  }

  async listAdmin(
    params: FileAccessGrantListFilters & {
      page: number;
      limit: number;
    }
  ): Promise<FileAccessGrantAdminListResponse> {
    const response = await this.api.get(this.root('admin'), { params });
    return response.data;
  }

  async exportAdminXlsx(params: FileAccessGrantListFilters & { page?: number; limit?: number }): Promise<Blob> {
    const response = await this.api.get(this.root('admin/xlsx'), {
      params,
      responseType: 'blob',
    });

    return response.data;
  }

  async getDistinctEntities(params?: FileAccessGrantListFilters): Promise<DistinctEntitiesDto> {
    const response = await this.api.get<DistinctEntitiesDto>(this.root('admin/distinct'), { params });
    return response.data;
  }
}
